export default __webpack_public_path__ + "static/media/DSC06798.71c38fb2.JPG";